import { useLanguage } from "../i18n/LanguageContext";

export const RouteMap = ({ compact = false }) => {
  const { t } = useLanguage();
  const pathD = "M150,290 C 300,180 460,250 655,140";

  return (
    <div
      data-testid="route-map"
      className={`relative rounded-2xl overflow-hidden border border-ops bg-ops-panel ${compact ? "" : ""}`}
    >
      <svg viewBox="0 0 800 400" className="w-full h-auto block" role="img" aria-label={t.cabotage.routeLabel}>
        <defs>
          <pattern id="opsgrid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M40 0H0V40" fill="none" stroke="rgba(46,168,223,0.07)" strokeWidth="1" />
          </pattern>
          <radialGradient id="opsglow" cx="50%" cy="45%" r="70%">
            <stop offset="0%" stopColor="rgba(46,168,223,0.10)" />
            <stop offset="100%" stopColor="rgba(46,168,223,0)" />
          </radialGradient>
        </defs>

        <rect width="800" height="400" fill="#0b1420" />
        <rect width="800" height="400" fill="url(#opsgrid)" />
        <rect width="800" height="400" fill="url(#opsglow)" />

        {/* stylized coastline */}
        <path
          d="M60,400 C 90,320 60,270 110,220 C 160,170 130,120 200,90 C 260,65 290,90 340,60"
          fill="none"
          stroke="rgba(46,168,223,0.25)"
          strokeWidth="1.5"
        />
        <path
          d="M800,330 C 720,300 740,240 680,210 C 640,190 660,150 620,120"
          fill="none"
          stroke="rgba(46,168,223,0.18)"
          strokeWidth="1.5"
        />

        {/* route */}
        <path d={pathD} fill="none" stroke="rgba(46,168,223,0.25)" strokeWidth="6" strokeLinecap="round" />
        <path d={pathD} fill="none" stroke="#2ea8df" strokeWidth="2" strokeLinecap="round" className="route-dash" />

        {/* moving vessel dot */}
        <circle r="5" fill="#ffffff">
          <animateMotion dur="7s" repeatCount="indefinite" path={pathD} />
        </circle>
        <circle r="10" fill="none" stroke="#2ea8df" strokeWidth="1" opacity="0.6">
          <animateMotion dur="7s" repeatCount="indefinite" path={pathD} />
        </circle>

        {/* origin node */}
        <circle cx="150" cy="290" r="8" fill="#08101a" stroke="#2ea8df" strokeWidth="2.5" />
        <circle cx="150" cy="290" r="3" fill="#2ea8df" />
        {/* destination node */}
        <circle cx="655" cy="140" r="8" fill="#08101a" stroke="#2ea8df" strokeWidth="2.5" />
        <circle cx="655" cy="140" r="3" fill="#2ea8df" />
      </svg>

      <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
        <div className="px-3 py-2 rounded bg-ops-base/85 border border-ops backdrop-blur-sm">
          <span className="mono-tag text-[9px] text-ops-light uppercase tracking-widest block">ORIGEM</span>
          <span className="text-sm font-display font-bold text-white">{t.cabotage.routeOrigin}</span>
        </div>
        <div className="px-3 py-2 rounded bg-ops-base/85 border border-ops backdrop-blur-sm text-right">
          <span className="mono-tag text-[9px] text-ops-light uppercase tracking-widest block">DESTINO</span>
          <span className="text-sm font-display font-bold text-white">{t.cabotage.routeDest}</span>
        </div>
      </div>

      <div className="absolute top-4 left-4">
        <span className="mono-tag text-[10px] text-ops-muted uppercase tracking-widest">{t.cabotage.routeLabel}</span>
      </div>
    </div>
  );
};
